module.exports = __webpack_public_path__ + "img/up_to_nine_months_hands_on_support.08c82cd1.png";